import { render, staticRenderFns } from "./message-details-subject-preview-block.vue?vue&type=template&id=a39cde6c&scoped=true&"
import script from "./message-details-subject-preview-block.vue?vue&type=script&lang=js&"
export * from "./message-details-subject-preview-block.vue?vue&type=script&lang=js&"
import style0 from "./message-details-subject-preview-block.vue?vue&type=style&index=0&id=a39cde6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39cde6c",
  null
  
)

export default component.exports